import React, { Component } from "react";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import UploadLT4Copperlimits from "./upload";

import { dateTimeFormatter } from "../../../common/utils";

class LT4CopperLimits extends React.Component {
  state = {
    modal: false
  };

  showModal(e) {
    this.setState({
      modal: true
    });
  }
  handleClose = e => {
    this.setState({
      modal: false
    });
  };

  render() {
    const { classes, translate, uploadLt4LimitDb, log } = this.props;
    const { modal } = this.state;

    let $modal = modal ? (
      <UploadLT4Copperlimits
        translate={translate}
        onClose={this.handleClose}
        uploadLt4LimitDb={uploadLt4LimitDb}
      />
    ) : null;

    return (
      <div>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Typography type="headline" color="inherit">
                {translate("settings_lt4copperlimitsdb")}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.info}>
              <Typography type="subheading" color="inherit">
                {translate("settings_lt4copper_limitsdb_label")}
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("profile_name")}:
                <b>
                  {log && log.cometlimitparser ? log.cometlimitparser.name : ""}
                </b>
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("settings_date_uploaded")}
                <b>
                  {log && log.cometlimitparser
                    ? dateTimeFormatter(log.cometlimitparser.createdat)
                    : ""}
                </b>
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("settings_version_number")}
                <b>
                  {log && log.cometlimitparser
                    ? log.cometlimitparser.Version
                    : ""}
                </b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                className={classes.orangeButton}
                fullWidth
                raised
                onClick={e => this.showModal(e)}
              >
                {translate("settings_upload")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
        {$modal}
      </div>
    );
  }
}
export default withStyles(styles)(LT4CopperLimits);
